var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 0.833984H6.00033C5.11627 0.833984 4.26842 1.18517 3.6433 1.8103C3.01818 2.43542 2.66699 3.28326 2.66699 4.16732V6.16732H0.666992V8.83398H2.66699V14.1673H5.33366V8.83398H7.33366L8.00033 6.16732H5.33366V4.16732C5.33366 3.99051 5.4039 3.82094 5.52892 3.69591C5.65395 3.57089 5.82351 3.50065 6.00033 3.50065H8.00033V0.833984Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebok);
export default __webpack_public_path__ + "static/media/facebok.4f2907490eaf8cbdc2cb8dbc68c8b754.svg";
export { ForwardRef as ReactComponent };